import {useState} from "react";
import { Fab } from "@mui/material";
import { RiChat1Fill } from "react-icons/ri";
import { MdOutlineClose } from "react-icons/md";
import { useConfig } from "../../../contexts/ConfigContext";
import { useChatWindowSettings } from "../../../contexts/ChatWindowContext";

const ChatFab = ({ chatFabRef }) => {
  const { config } = useConfig();
  const [imageError, setImageError] = useState(false);
  const { open, setOpen, isMobile, isReady } = useChatWindowSettings();

  return (
    <Fab
      size={isMobile ? "medium" : "large"}
      onClick={() => setOpen(!open)}
      disableRipple
      ref={chatFabRef}
      disabled={!isReady}
      sx={{
        width: "65px",
        height: "65px",
        right: config?.position?.right,
        bottom: config?.position?.bottom,
        backgroundColor: config?.color.chatButtonBackground,
        border: config.color.iconCircleBorder
          ? `2px solid ${config.color.iconCircleBorder}`
          : 0,
        position: "fixed",
        visibility: isReady ? "visible" : "hidden !important",
        zIndex: 1000,
        "&:hover": {
          backgroundColor: config?.color.chatButtonBackground,
          border: config?.color.iconCircleBorder
            ? `2px solid ${config?.color.chatButtonBackground}`
            : 0,
        },
      }}
    >
      {open ? (
        <MdOutlineClose
          color={config?.color.chatButtonIconColor}
          fontSize={25}
        />
      ) : config?.chatButtonImage && !imageError ? (
        <img
          onError={() => setImageError(true)}
          src={config?.chatButtonImage}
          alt="chatbot"
          style={{ maxWidth: "40px", maxHeight: "40px" }}
        />
      ) : (
        <RiChat1Fill color={config?.color.chatButtonIconColor} fontSize={35} />
      )}
    </Fab>
  );
};

export default ChatFab;
